/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["[_nghost-%COMP%], [_nghost-%COMP%]   .main[_ngcontent-%COMP%]{display:flex;flex-direction:column}.show-sidebar[_nghost-%COMP%]{flex-direction:row}"];
export { styles as styles };

